import React from 'react'
import { getLayerTypeIcon } from '../../lib/skycity.js'

export default function LayerType ({
    layer
}) {
    return <div className="icon-space-right">{getLayerTypeIcon(layer)}</div>
}
